import { ApolloCache, DefaultContext, FetchResult, MutationFunctionOptions } from "@apollo/client";
import { handleServerCartResponse } from "@/redux/slice/cart/utils/handleServerCartResponse";
import { CartInputDataV2, GuestCartInputDataV2 } from "@/components/graphql/types/globalTypes";
import { saveCartV2, saveCartV2Variables } from "@/components/graphql/types/saveCartV2";
import {
  setAllowServerUpdate,
  setCartFetchingUpdating,
  setGuestUserActionPayload,
  setUpdatingCart,
  setUserActionPayload,
} from "@/redux/slice/cart/slice";
import { ThunkResolvedStatus } from "@/libs/enum/ThunkResolvedStatus";
import { guestSaveCartApi } from "./guestSaveCartApi";
import { isBrowser } from "@/helpers/isBrowser";

type SaveServerCartPayload = {
  dispatch: Function;
  cartInputDataV2?: CartInputDataV2;
  guestCartInputDataV2?: GuestCartInputDataV2;
  saveCartMutation?: (
    options?: MutationFunctionOptions<saveCartV2, saveCartV2Variables, DefaultContext, ApolloCache<object>>
  ) => Promise<FetchResult<saveCartV2>>;
  setIsCartFetchingUpdatingRequired?: (isCartFetchingUpdatingRequired: boolean) => void;
  isCartFetchingUpdatingRequired?: boolean;
};

export const saveServerCart = async ({
  cartInputDataV2,
  guestCartInputDataV2,
  dispatch,
  saveCartMutation,
  setIsCartFetchingUpdatingRequired,
  isCartFetchingUpdatingRequired,
}: SaveServerCartPayload) => {
  dispatch(setAllowServerUpdate(false));
  dispatch(setUpdatingCart(ThunkResolvedStatus.pending));

  try {
    let saveCartResponse;
    if (cartInputDataV2?.patientId) {
      const response = await saveCartMutation({
        variables: {
          cartInputDataV2,
        },
      });
      saveCartResponse = response?.data?.saveCartV2;
    } else {
      const response = await guestSaveCartApi(guestCartInputDataV2);
      response?.data?.id &&
        isBrowser() &&
        localStorage.setItem("guestCartId", response?.data?.id as string);
      saveCartResponse = response;
    }
    await handleServerCartResponse(
      saveCartResponse,
      dispatch
    );
    dispatch(setUpdatingCart(ThunkResolvedStatus.fulfilled));
    if (isCartFetchingUpdatingRequired) {
      dispatch(setCartFetchingUpdating(ThunkResolvedStatus.fulfilled));
      setIsCartFetchingUpdatingRequired &&
        setIsCartFetchingUpdatingRequired(false);
    }
    if (isBrowser()) {
      localStorage.removeItem("cartItems");
      localStorage.removeItem("circlePlanId");
    }
    // setPhoneNumberUpdatedTag(true);
  } catch (saveCartError) {
    dispatch(setUpdatingCart(ThunkResolvedStatus.rejected));
    console.error("Failed to sync server cart", saveCartError);
  } finally {
    dispatch(setUserActionPayload(null));
    dispatch(setGuestUserActionPayload(null));
    dispatch(setAllowServerUpdate(true));
  }
}